import styled from 'styled-components';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import Small from 'UIComponents/elements/Small';
import UIIcon from 'UIComponents/icon/UIIcon';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import useIlsListSize from 'automation-ui-enrollment/hooks/useILSListSize';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledUILoadingSpinner = styled(UILoadingSpinner).withConfig({
  displayName: "ILSListSizeLabel__StyledUILoadingSpinner",
  componentId: "sc-18di8mg-0"
})(["display:inline-block;position:fixed;"]);
const ILSListSizeLabel = ({
  listId,
  objectTypeId
}) => {
  const listCountData = useIlsListSize({
    listId
  });
  if (listCountData.error) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: ['---', /*#__PURE__*/_jsx(Text, {
        paddingBlockEnd: "0",
        marginBlockEnd: "0",
        as: "p",
        children: /*#__PURE__*/_jsxs(Small, {
          use: "error",
          children: [/*#__PURE__*/_jsx(UIIcon, {
            name: "warning",
            className: "p-right-2"
          }), /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
            baseLangKey: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.listCountError_cob",
            objectTypeId: objectTypeId
          })]
        })
      })]
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [listCountData.loading && /*#__PURE__*/_jsx(StyledUILoadingSpinner, {
      size: "extra-small",
      className: "p-all-0 m-all-1"
    }), !listCountData.loading && listCountData.listSize]
  });
};
export default ILSListSizeLabel;